import { ATDLEnumModel } from "./atdl-enum.model";
import { ATDLInterfaceDependencyModel } from "./atdl-interface-dependency.model";
import { ATDLInterfaceAuxiliaryModel } from "./atdl-interface-auxiliary.model";
// ICD Models
import { ICNInputControlState } from "app/order-entry/interface/controls/models/bfx-interface-controls.enums";
import { ATDLNControlType } from "../enums/atdl-control-type.enum";
import { ATDLNParameterType } from "../enums/atdl-parameter-type.enum";

export class ATDLInterfaceControlModel {
  // CONTROLs [location: .Strategies.lay:StrategyLayout.lay:StrategyPanel.lay:StrategyControl -> array -> $]
  public icdId: string = null; // mapping: 'ID' | example: "c_LimitPrice"
  public label: string = null; // mapping: 'label' | example: "Limit Price"
  public refName: string = null; // mapping: 'limitPrice' | "limitPrice"
  public icdType: ATDLNControlType = null; // mapping: xsi:type | example: "lay:SingleSpinner_t".replace('lay:');
  public icdTypeText: string = null;
  public initValue: string = null; // mapping: 'initValue' | example: "0"
  // defaultValue is not ATDL compliant but it is used in some of the BcdFX Algos
  public defaultValue: string = null; // mapping: 'defaultValue' | example: "hybrid"
  // StateFlow - dependency to other algo panel controls
  public dependencies: Array<ATDLInterfaceDependencyModel> = null;
  // Additional nested control (usually checkbox)
  public auxiliary: Array<ATDLInterfaceAuxiliaryModel> = null;
  // [location: .Strategies.lay:StrategyLayout.lay:StrategyPanel.lay:StrategyControl -> array -> lay:ListItem -> array -> $]
  public dataset: Array<ATDLEnumModel> = null; //	[{enumId: 'bid': uiRep: 'Bid'},..]
  // special properties - icdType dependent
  public checkedEnumRef: string = null; // only for checkbox
  public uncheckedEnumRef: string = null; // only for checkbox
  public increment: string = null; // only for spinner
  public incrementPolicy: string = null; // only for spinner
  public radioGroup: string = null; // only for radio-list
  // BFX extension of ATDL
  public disableOnPartFill: boolean = false;
  // not in use just parsed
  public tooltip: string = null; // not in use just parsed
  public initFixField: string = null;
  public initPolicy: string = null;
  public disableForTemplate: string = null;
  ///////////////////////////////
  // META (copy from parameter)
  public algoId: string = null;
  public paramType: ATDLNParameterType = null; // added because icdType needs to take into account paramType (eg Price requires Rate Spinner)
  public validity: {
    required: boolean; // mapping: 'use' | "required" => true , "optional" => false
    minValue: number | string;
    maxValue: number | string;
    minLength: number;
    maxLength: number;
  } = {
    required: null,
    minValue: null,
    maxValue: null,
    minLength: null,
    maxLength: null,
  };
  public precision: number = null;
  ///////////////////////////////
  // UI - Parameters
  public value: any = null; // UI
  private _validState: ICNInputControlState = ICNInputControlState.INACTIVE;
  public get validState(): ICNInputControlState {
    return this._validState;
  }
  public set validState(value: ICNInputControlState) {
    this._validState = value;
  }
  public errorMsg: string = null;

  // State rules (dependency models) that assigned NULL value to this control
  public nullingDependencyModels: Array<ATDLInterfaceDependencyModel> = [];

  constructor(icdId?: string, refName?: string) {
    this.icdId = icdId;
    this.refName = refName;
  }
}
